import React from 'react';
import Location from '../Components/UserLocation/userlocation';

const LocationPage = () => (
    < div >
        <Location />
    </div >
)

export default LocationPage;